import { useRecordContext } from 'ra-core';
import { ListButton } from 'react-admin';

export const LinkToPayments = () => {
  const record = useRecordContext();
  const { id } = record;
  return <ListButton to={`/subscriptions/${id}/payments`} label={'Payments'} />;
};
